import { Link } from '@tanstack/react-router'

type FooterProps = {
  supportEmail?: string
}

const Footer = ({ supportEmail = 'portal-support@curitec.com' }: FooterProps) => {
  return (
    <footer className='border-t bg-base-100'>
      <div className='container mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8'>
        <div className='py-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between text-sm text-base-content/70'>
          <div>
            Support:{' '}
            <a
              href={`mailto:${supportEmail}`}
              className='link link-primary'
            >
              {supportEmail}
            </a>
          </div>
          <Link
            to='/privacy-policy'
            className='link link-primary'
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  )
}

export default Footer
